<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div v-if="resCol === '12'">
      <v-dialog v-model="dialogQC" persistent fullscreen>
            <v-card>
              <v-form ref="form" v-model="validQC" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row style="padding-top:15px;padding-bottom:15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h2>หลักฐานชำระเงิน</h2>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click=";(dialogQC = false), clearData()"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-card class="mx-auto my-12" max-width="374">
                        <v-img
                          contain
                          max-height="600"
                          min-heighr="400"
                          width="450"
                          :src="view.paymentPicUrl"
                        ></v-img>
                      </v-card>
                    </v-row>
                    <v-row>
                      <v-col class="text-right">
                        <v-btn color="success" @click="conF()"
                          >ยืนยัน</v-btn
                        >
                      </v-col>
                      <v-col class="text-left">
                        <v-btn
                          color="error"
                          dark
                          @click=";(dialogQC = false), (dialogRemark = true)"
                          >ยกเลิก</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogRemark" persistent fullscreen>
            <v-card>
              <v-form ref="form" v-model="validRemark" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-textarea
                          v-model="view.remark"
                          outlined
                          name="input-10-7"
                          label="หมายเหตุ"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="text-right">
                        <v-btn color="success" dark @click="canC()"
                          >ยืนยัน</v-btn
                        >
                      </v-col>
                      <v-col class="text-left">
                        <v-btn color="error" dark @click="cancel()"
                          >ยกเลิก</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
        </div>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4" v-if="resCol === '6'">
        <v-row>
          <v-dialog v-model="dialogQC" persistent max-width="40%">
            <v-card>
              <v-form ref="form" v-model="validQC" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row style="padding-top:15px;padding-bottom:15px">
                      <v-col style="padding: 15px 16px 0px">
                        <h2>หลักฐานชำระเงิน</h2>
                      </v-col>
                      <v-col class="text-right">
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click=";(dialogQC = false), clearData()"
                        >
                          <v-icon color="#173053">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-card class="mx-auto my-12" max-width="374">
                        <v-img
                          contain
                          max-height="600"
                          min-heighr="400"
                          width="450"
                          :src="view.paymentPicUrl"
                        ></v-img>
                      </v-card>
                    </v-row>
                    <v-row>
                      <v-col class="text-right">
                        <v-btn color="success" dark :loading="loading" @click="conF()"
                          >ยืนยัน</v-btn
                        >
                      </v-col>
                      <v-col class="text-left">
                        <v-btn
                          color="error"
                          dark
                          @click=";(dialogQC = false), (dialogRemark = true)"
                          >ยกเลิก</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogRemark" persistent max-width="40%">
            <v-card>
              <v-form ref="form" v-model="validRemark" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-textarea
                          v-model="view.remark"
                          outlined
                          name="input-10-7"
                          label="หมายเหตุ"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="text-right">
                        <v-btn color="success" dark @click="canC()"
                          >ยืนยัน</v-btn
                        >
                      </v-col>
                      <v-col class="text-left">
                        <v-btn color="error" dark @click="cancel()"
                          >ยกเลิก</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>

        </v-row>
      </div>
      <div >
        <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-tabs v-model="tab" background-color="#1B437C" dark>
                <v-tab> รอรับยืนยัน </v-tab>
                <v-tab> ยืนยันแล้ว </v-tab>
                <v-tab> ยกเลิก </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card-title>
                    <v-text-field
                      v-model="searchAll2"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="columns"
                      :items="dataItem.filter(item => item.CHKstatus === 'รอยืนยัน')"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.packageImg`]="{ item }">
                        <v-avatar color="primary" size="40">
                          <img :src="item.packageImg" alt="img"
                        /></v-avatar>
                      </template>

                      <template v-slot:[`item.point`]="{ item }">
                        {{ formatNumber(item.point) }}
                      </template>
                      <template v-slot:[`item.LAST_DATE`]="{ item }">
                        {{ thaiFormattedDate(item.LAST_DATE) }}
                      </template>
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ thaiFormattedLAST_Date(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.CHKstatus`]="{ item }">
                        <v-chip :color="getColor(item.CHKstatus)" dark>
                          {{ item.CHKstatus }}
                        </v-chip>
                      </template>
                      <template v-slot:[`item.priviledge`]="{ item }">
                        <nl2br tag="p" :text="item.priviledge" />
                      </template>
                      <template v-slot:[`item.color`]="{ item }">
                        <v-card
                          class="mx-auto card-index div_color"
                          width="120"
                          height="70"
                          color="#E0E0E0"
                        >
                          <div
                            :style="'background-color:' + item.color"
                            class="rotate"
                          ></div>
                        </v-card>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="success"
                              fab
                              dark
                              id="v-step-2"
                              x-small
                              @click.stop="getDataItem(item), (dialogQC = true)"
                            >
                              <v-icon dark> mdi-quality-high </v-icon>
                            </v-btn>
                          </template>
                          <span>ตรวจสอบการโอนเงิน</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-tab-item>
                <v-tab-item>
                    <v-text-field
                      v-model="searchAll2"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  <v-card-text>
                    <v-data-table
                      :headers="columns"
                      :items="dataItem.filter(item => item.CHKstatus === 'ยืนยัน')"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.packageImg`]="{ item }">
                        <v-avatar color="primary" size="40">
                          <img :src="item.packageImg" alt="img"
                        /></v-avatar>
                      </template>

                      <template v-slot:[`item.point`]="{ item }">
                        {{ formatNumber(item.point) }}
                      </template>
                      <template v-slot:[`item.LAST_DATE`]="{ item }">
                        {{ thaiFormattedDate(item.LAST_DATE) }}
                      </template>
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ thaiFormattedLAST_Date(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.CHKstatus`]="{ item }">
                        <v-chip :color="getColor(item.CHKstatus)" dark>
                          {{ item.CHKstatus }}
                        </v-chip>
                      </template>
                      <template v-slot:[`item.priviledge`]="{ item }">
                        <nl2br tag="p" :text="item.priviledge" />
                      </template>
                      <template v-slot:[`item.color`]="{ item }">
                        <v-card
                          class="mx-auto card-index div_color"
                          width="120"
                          height="70"
                          color="#E0E0E0"
                        >
                          <div
                            :style="'background-color:' + item.color"
                            class="rotate"
                          ></div>
                        </v-card>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="success"
                              fab
                              dark
                              id="v-step-2"
                              x-small
                              @click.stop="getDataItem(item), (dialogQC = true)"
                            >
                              <v-icon dark> mdi-quality-high </v-icon>
                            </v-btn>
                          </template>
                          <span>ตรวจสอบการโอนเงิน</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-tab-item>
                <v-tab-item>
                    <v-text-field
                      v-model="searchAll2"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  <v-card-text>
                    <v-data-table
                      :headers="columns"
                      :items="dataItem.filter(item => item.CHKstatus === 'ยกเลิก')"
                      :search="searchAll2"
                      :items-per-page="10"
                    >
                      <template v-slot:[`item.packageImg`]="{ item }">
                        <v-avatar color="primary" size="40">
                          <img :src="item.packageImg" alt="img"
                        /></v-avatar>
                      </template>

                      <template v-slot:[`item.point`]="{ item }">
                        {{ formatNumber(item.point) }}
                      </template>
                      <template v-slot:[`item.LAST_DATE`]="{ item }">
                        {{ thaiFormattedDate(item.LAST_DATE) }}
                      </template>
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ thaiFormattedLAST_Date(item.CREATE_DATE) }}
                      </template>
                      <template v-slot:[`item.CHKstatus`]="{ item }">
                        <v-chip :color="getColor(item.CHKstatus)" dark>
                          {{ item.CHKstatus }}
                        </v-chip>
                      </template>
                      <template v-slot:[`item.priviledge`]="{ item }">
                        <nl2br tag="p" :text="item.priviledge" />
                      </template>
                      <template v-slot:[`item.color`]="{ item }">
                        <v-card
                          class="mx-auto card-index div_color"
                          width="120"
                          height="70"
                          color="#E0E0E0"
                        >
                          <div
                            :style="'background-color:' + item.color"
                            class="rotate"
                          ></div>
                        </v-card>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="success"
                              fab
                              dark
                              id="v-step-2"
                              x-small
                              @click.stop="getDataItem(item), (dialogQC = true)"
                            >
                              <v-icon dark> mdi-quality-high </v-icon>
                            </v-btn>
                          </template>
                          <span>ตรวจสอบการโอนเงิน</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api

export default {
  components: {},
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  data () {
    return {
      model: null,
      loading: false,
      tab: null,
      session: this.$session.getAll(),
      dialogAdd: false,
      dialogQC: false,
      validAdd: true,
      validQC: true,
      dialogRemark: false,
      validRemark: true,
      formAdd: {
        payType: 'promptpay',
        promtpayName: '',
        promtpayNumber: '',
        masBranchID: null,
        payImage: '',
        pictureUrlPreview: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId
      },
      formUpdate: {
        Id: '',
        payType: '',
        promtpayName: '',
        promtpayNumber: '',
        masBranchID: null,
        payImage: '',
        pictureUrlPreview: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: this.$session.getAll().data.shopId
      },
      view: {
        paymentPicUrl: '',
        status: '',
        remark: '',
        shopId: this.$session.getAll().data.shopId
      },
      formSelect: [],
      // session: this.$session.getAll(),
      filesAdd: null,
      filesUpdate: null,
      columns: [
        { text: 'รูป', value: 'packageImg' },
        { text: 'ชื่อแพ็กเกจ', value: 'packageName' },
        { text: 'ราคาแพ็กเกจ', value: 'packagePrice' },
        { text: 'ผู้ซื้อ', value: 'name' },
        { text: 'สถานะชำระเงิน', value: 'CHKstatus' },
        { text: 'วันที่ซื้อ', value: 'CREATE_DATE' },
        { text: 'หมายเหตุ', value: 'remark' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      id: '',
      searchAll2: ''
    }
  },
  // beforeCreate () {
  //   if (!this.$session.exists()) {
  //     this.$router.push('/Core/Login')
  //   }
  // },
  async mounted () {
    if (this.$session.getAll().data === undefined) {
      this.$router.push(
        '/Core/Login?access=KNYW6L9LPgSgWPvMzGUBPhPXH52ZdndSpq4Ez8SXMzGu3tBvfEFCrYKK86usU7FE47VKpuVCqe3YPA2CHsnZXshcsKG7A4ZaEWUW&callBack=' +
          this.$route.fullPath
      )
    }
    await this.getData()
    await this.getPrompt()
    await this.getColor()
  },
  methods: {
    getColor (CHKstatus) {
      if (CHKstatus === '') {
        return ''
      } else if (CHKstatus === 'ยืนยัน') return 'green'
      else if (CHKstatus === 'รอยืนยัน') return 'orange'
      else return 'red'
    },
    async getData () {
      if (!this.DNS_IP) {
        location.reload()
      } else {
        await axios
          .get(
            this.DNS_IP +
            '/PackageLog/get?shopId=' +
            this.$session.getAll().data.shopId
          )
          .then(res => {
            this.dataItem = res.data

            console.log('res', this.dataItem)
          }).catch(error => console.log(error))
      }
    },
    getDataItem (item) {
      console.log('item', item)
      this.id = item.idPackageLog
      axios
        .get(
          this.DNS_IP + '/PackageLog/getID?idPackageLog=' + item.idPackageLog
        )
        .then(res => {
          console.log('resData', res.data)
          this.formUpdate.payType = res.data.payType
          this.formUpdate.promtpayName = res.data.promtpayName
          this.formUpdate.promtpayNumber = res.data.promtpayNumber
          this.formUpdate.masBranchID = res.data.masBranchID
          this.formUpdate.payImage = res.data.payImage
          this.formUpdate.pictureUrlPreview = res.data.payImage
          this.formUpdate.CREATE_USER = res.data.CREATE_USER
          this.formUpdate.LAST_USER = res.data.LAST_USER
          this.formUpdate.shopId = res.data.shopId
          this.formUpdate.status = res.data.status
          this.view.paymentPicUrl = res.data.paymentPicUrl
          this.view.packageId = res.data.packageId
        })
    },
    getPrompt () {
      this.formAdd.payType = 'promptpay'
      axios
        .get(
          'https://api-belinked.betaskthai.tech/flow/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(res => {
          res.data.map(el => {
            this.formSelect.push(el)
          })
          console.log(this.formSelect)
        })
    },
    select (i) {
      console.log('i', i)
      this.formAdd.promtpayName = i.promptPayName
      this.formAdd.promtpayNumber = i.promptPayID
    },
    async conF () {
      this.view.status = 'use'
      this.loading = true
      await axios
        .post(this.DNS_IP + '/package/update/' + this.id, this.view)
        .then(res => {
          console.log('editDataGlobal DNS_IP + PATH + "edit"', res)
          this.loading = false
          this.$swal('เรียบร้อย', 'ยืนยันการชำระเงินสำเร็จ', 'success')
          this.getData()
          this.dialogQC = false
          this.view.remark = ''
          this.view.paymentPicUrl = ''
          this.view.status = ''
        })
    },
    canC () {
      this.view.status = 'cancel'
      axios
        .post(this.DNS_IP + '/package/update/' + this.id, this.view)
        .then(res => {
          console.log('editDataGlobal DNS_IP + PATH + "edit"', res)
          this.$swal('เรียบร้อย', 'ยกเลิกใบเสร็จชำระเงิน', 'success')
          this.getData()
          this.dialogRemark = false
          this.view.remark = ''
          this.view.paymentPicUrl = ''
          this.view.status = ''
        })
    },
    cancel () {
      this.view.remark = ''
      this.view.paymentPicUrl = ''
      this.view.status = ''
      this.dialogRemark = false
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/System/confirmPayment.vue